/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-unused-vars */
/**
 * @author Granite Bagas
 */

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import { useDispatch } from 'react-redux';
import Toast from 'react-native-toast-message';

import MoreButton from '@components/navbar/MoreButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Button from '@components/form/Button';
import * as Layout from '@components/screen/Layout';
import StatusBadge from '@components/global/StatusBadge';
import Image from '@components/global/Image';
import ModalLog from '@components/modal/ModalLog';
import RenderIf from '@components/global/RenderIf';
import BackButton from '@components/navbar/BackButton';
import FloatCommentButton from '@components/comment/FloatCommentButton';
import CommentHeaderButton from '@components/comment/CommentHeaderButton';
import CommentDrawer from '@components/comment/CommentDrawer';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { hasNoAccess } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsOrder, deleteProductListing } from '@api/ms-order';
import { REQUEST_PRODUCT_ELIGIBILITY_LOG_FORMATTER } from '@/constants/log';
import ProductListingTab from './components/ProductListingTab';
import { showAlert } from '@/store/global';
import { paramsReseted } from '@/store/params';
import {
  REQUEST_PRODUCT_LISTING_ITEMS,
  REQUEST_PRODUCT_LISTING_SUMMARY_ITEMS,
  REQUEST_PRODUCT_LISTING_SUMMARY_LOG_ITEMS,
} from '@/constants/table-name';

const img = require('@/assets/img/default/user-image.png');

const RequestProductListingDetailScreen = (props) => {
  const year = props?.route?.params?.year;
  const listingId = props?.route?.params?.id;

  const dispatch = useDispatch();

  const didFetchRef = useRef(false);

  const [detailData, setDetailData] = useState({});
  const [showModalLog, setShowModalLog] = useState(false);
  const [mobileTab, setMobileTab] = useState(0);
  const [showComments, setShowComments] = useState(
    props.route.params?.openComments === 'true',
  );

  const getProductListingDetail = useApi(MsOrder.getProductListingDetail);

  const hasAccessEdit = !hasNoAccess([
    'superadmin',
    'general',
    'general_manager_marketing',
  ]);

  const getDetail = async (id) => {
    const response = await getProductListingDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;

      setDetailData(result);
    }
  };

  const resetData = () => {
    setDetailData({});
    setShowModalLog(false);
    setMobileTab(0);
    dispatch(paramsReseted({ key: REQUEST_PRODUCT_LISTING_ITEMS }));
    dispatch(paramsReseted({ key: REQUEST_PRODUCT_LISTING_SUMMARY_ITEMS }));
    dispatch(paramsReseted({ key: REQUEST_PRODUCT_LISTING_SUMMARY_LOG_ITEMS }));
  };

  const goBack = () => {
    if (mobileTab === 0) {
      props.navigation.replace('RequestProductListingDetailScreen', {});
      props.navigation.navigate('RequestProductListingScreen', {
        titleScreen: `${year}`,
        name: `${year}`,
        year: `${year}`,
        go_back_key: props.route.key,
      });
    } else {
      setMobileTab(0);
    }
  };

  const handleEdit = () => {
    props.navigation.navigate('RequestProductListingFormScreen', {
      titleScreen: detailData?.customer?.code,
      name: detailData?.customer?.code,
      year: `${year}`,
      go_back_key: props.route.key,
      id: detailData?._id,
    });
  };

  const handleDelete = () => {
    dispatch(
      showAlert({
        show: true,
        title: 'Delete data',
        description:
          'This product listing will be deleted. Do you want to proceed?',
        onCallback: async (val) => {
          try {
            await deleteProductListing(listingId);
            Toast.show({
              text1: 'Successfully delete data',
              type: 'success',
            });
            goBack();
          } catch (e) {
            console.log(e);
          }
        },
      }),
    );
  };

  useFocusEffect(
    useCallback(() => {
      if (!didFetchRef.current) {
        didFetchRef.current = true;
        resetData();
        if (listingId) {
          getDetail(listingId);
        }
      }

      return () => {
        didFetchRef.current = false;
        resetData();
      };
    }, [props.route]),
  );

  useEffect(() => {
    try {
      const menus = [];
      if (hasAccessEdit) {
        menus.push({
          type: 'function',
          name: 'Edit',
          callback: handleEdit,
        });
        // menus.push({
        //   type: 'function',
        //   name: 'Delete',
        //   callback: handleDelete,
        // });
      }
      props.navigation.setOptions({
        headerLeft: () => (
          <BackButton
            {...props}
            notUseLastRoute={true}
            onPress={() => goBack()}
          />
        ),
        headerRight: () => {
          return isWeb ? (
            <NotificationSettingButton {...props} />
          ) : (
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              {detailData._id ? (
                <CommentHeaderButton
                  onPress={() => setShowComments(true)}
                  drawerVisible={showComments}
                  entityType="request_product_eligibility"
                  entityId={detailData._id}
                />
              ) : (
                false
              )}
              <MoreButton menu={menus} {...props} />
            </View>
          );
        },
      });
    } catch (error) {}
  }, [props.navigation, detailData, mobileTab, showComments]);

  return (
    <Layout.Container>
      {getProductListingDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : detailData && Object.keys(detailData).length ? (
        <View>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back title={year} onCallback={() => goBack()} />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <Layout.Wrapper rounded fullWidth isUndefined>
            <RenderIf condition={isWeb || (!isWeb && mobileTab === 0)}>
              <ScrollView
                contentContainerStyle={{ width: '100%' }}
                keyboardShouldPersistTaps="handled">
                <View style={styles.sectionWrapper}>
                  <View
                    style={[
                      styles.rowContainer,
                      {
                        position: 'relative',
                        zIndex: 1,
                        justifyContent: 'space-between',
                      },
                    ]}>
                    <View
                      style={{ flexDirection: 'row', alignItems: 'center' }}>
                      <Image
                        style={{
                          width: 50,
                          height: 50,
                          margin: 10,
                        }}
                        width={50}
                        height={50}
                        isPhoto={true}
                        source={
                          detailData?.customer?.image
                            ? detailData.customer.image
                            : img
                        }
                      />
                      <SociollaText type="medium" style={{ fontSize: 20 }}>
                        {detailData?.customer?.name || ''}
                      </SociollaText>
                    </View>
                    {isWeb && (
                      <View style={{ flexDirection: 'row' }}>
                        <RenderIf condition={hasAccessEdit}>
                          <Button
                            type="default"
                            rounded
                            buttonStyle={{ width: 80, marginRight: 10 }}
                            title={
                              <SociollaText
                                type="bold"
                                style={{ color: Colors.black }}>
                                Edit
                              </SociollaText>
                            }
                            onPress={handleEdit}
                          />
                          {/* <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 80, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Delete
                            </SociollaText>
                          }
                          onPress={handleDelete}
                        /> */}
                        </RenderIf>
                      </View>
                    )}
                  </View>

                  <View
                    style={[
                      { width: '100%' },
                      isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                    ]}>
                    <ItemDetail
                      name="Customer Code"
                      value={
                        detailData.customer.code
                          ? detailData.customer.code
                          : '-'
                      }
                    />
                    <ItemDetail
                      name="Log"
                      valueComponent={
                        <View
                          style={{
                            marginLeft: 18,
                            marginTop: 5,
                          }}>
                          <TouchableOpacity
                            onPress={() => setShowModalLog(true)}>
                            <SociollaText
                              style={{
                                fontSize: 12,
                                color: Colors.blue0,
                                zIndex: 99,
                              }}>
                              see log
                            </SociollaText>
                          </TouchableOpacity>
                        </View>
                      }
                    />
                    <ItemDetail
                      name="Is Active"
                      centered
                      value={
                        <StatusBadge
                          status={detailData.is_active ? 'active' : 'in_active'}
                        />
                      }
                    />
                  </View>
                </View>
                <RenderIf condition={!isWeb}>
                  <View style={styles.divider} />
                  <View style={styles.tabContainer}>
                    <TouchableOpacity
                      style={styles.tabItem}
                      onPress={() => setMobileTab(1)}>
                      <SociollaText>Product Listings</SociollaText>
                      <Image
                        source={require('@/assets/img/icons/arrow-right-grey.svg')}
                        style={{ width: 10, height: 15 }}
                        width={10}
                        height={15}
                        svg={true}
                      />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.tabItem}
                      onPress={() => setMobileTab(2)}>
                      <SociollaText>Product Summary & Logs</SociollaText>
                      <Image
                        source={require('@/assets/img/icons/arrow-right-grey.svg')}
                        style={{ width: 10, height: 15 }}
                        width={10}
                        height={15}
                        svg={true}
                      />
                    </TouchableOpacity>
                  </View>
                </RenderIf>
              </ScrollView>
            </RenderIf>

            <ProductListingTab
              id={listingId}
              detailData={detailData}
              mobileTab={mobileTab}
              navigation={props.navigation}
            />
          </Layout.Wrapper>
        </View>
      ) : (
        false
      )}

      {showModalLog && (
        <ModalLog
          show={showModalLog}
          status={detailData.is_active ? 'active' : 'in_active'}
          onClose={() => setShowModalLog(false)}
          logType="product_listing"
          logId={listingId}
          logLabel="Product Listing"
          data={detailData}
          logFormatter={REQUEST_PRODUCT_ELIGIBILITY_LOG_FORMATTER}
        />
      )}

      {detailData._id ? (
        <>
          {isWeb ? (
            <FloatCommentButton
              onPress={() => setShowComments(true)}
              drawerVisible={showComments}
              entityType="request_product_eligibility"
              entityId={detailData._id}
              // This screen has its own paginated table pinned to the bottom of the viewport —
              // the default offset overlaps its pagination controls, unlike the other 5 screens.
              bottomOffset={10}
            />
          ) : (
            false
          )}
          <CommentDrawer
            visible={showComments}
            onClose={() => setShowComments(false)}
            entityType="request_product_eligibility"
            entityId={detailData._id}
            entityRef={detailData.customer?.code}
          />
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', paddingHorizontal: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  divider: {
    height: 8,
    backgroundColor: Colors.grey0,
  },
  tabContainer: {
    paddingHorizontal: 15,
  },
  tabItem: {
    paddingVertical: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export default RequestProductListingDetailScreen;
